import { useNavigate } from "react-router-dom";
import React from "react";

const PromjenaPinaUspjesna = () => {

    let navigate = useNavigate();

    const onSubmit = async (data) => {
        console.log(data);
        navigate('/nalog');
    }

    return (
        <div id="registerPagePhoneNumber" className="lightContent center">
            <div className="wizardCenterArea">
                <div className="mainTitle spacer spacerUp">PIN je uspješno promijenjen!</div>
                <div className="standardText">Sada možeš da se vratiš nazad na podešavanja naloga.
                </div>
                <div className="centerWrapper">
                    <button className="mainActionButton center" type="submit" onClick={onSubmit}>Podešavanja naloga</button>
                </div>
            </div>

        </div>
    )
}

export default PromjenaPinaUspjesna;